 export default class TextureHelper {
    static getTemplateByIndex(index: number = 0) {    
        let templatePositions = ["Square", "Portrait", "Landscape", "Portrait", "Landscape", "Square", "Landscape", "Square", "Portrait"];
        let positionIndex: number = index < templatePositions.length ? index : index % templatePositions.length;
        return templatePositions[positionIndex];
    }
}